import React from "react";
import { Button, useTheme, useMediaQuery } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     margin: theme.spacing(2, 1, 2),
//   },
// }));

const PrimaryButton = ({ children, ...props }) => {
  // const styles = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Button
      variant="contained"
      color="primary"
      // className={styles.root}
      size={mobile ? "small" : "default"}
      sx={{ margin: theme.spacing(2, 1, 2) }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
